const LOCAL_DEV_HOST_SUFFIXES = ['localhost', '127.0.0.1'];

export function hostnameFromUrl(url: string): string | null {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export function isLocalDevHost(hostname: string): boolean {
  return LOCAL_DEV_HOST_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
}
